import styles from './Pagination.module.css';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Pagination = ({ totalPages = 5 }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
            navigate(`/page/${page}`); // Navigate to the dynamic page
        }
    };

    return (
        <div className={styles.style}> 
            <div className={styles.container}>
                <div className={styles.paginationWrapper}>
                    <div className={styles.pagination}>
                        <button 
                            onClick={() => handlePageChange(currentPage - 1)} 
                            className={styles.arrow} 
                            disabled={currentPage === 1}>
                            &laquo;
                        </button>
                        <button 
                            className={styles.activePage}
                            onClick={() => handlePageChange(currentPage)}>
                            {currentPage}
                        </button>
                        <button 
                            onClick={() => handlePageChange(currentPage + 1)} 
                            className={styles.arrow} 
                            disabled={currentPage === totalPages}>
                            &raquo;
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Pagination;
